import { ChatMessageGroup, TransformedMessage } from '@provision/chat-utils';
import dayjs, { Dayjs } from 'dayjs';

export function partitionGroupMessagesByTimeWindows<T>(
  messageGroup: ChatMessageGroup<T>,
  orderedTimeWindows: Dayjs[],
): ChatMessageGroup<T>[] {
  if (messageGroup.messages.length <= 1) {
    return [messageGroup];
  }
  const startMessageGroupDate = dayjs(messageGroup.createdAt);
  const endMessageGroupDate = dayjs(
    messageGroup.messages[messageGroup.messages.length - 1].createdAt,
  );

  const startTimeWindowIndex = orderedTimeWindows.findLastIndex((d) =>
    d.isBefore(startMessageGroupDate),
  );
  const endTimeWindowIndex = orderedTimeWindows.findIndex((d) =>
    d.isAfter(endMessageGroupDate),
  );

  if (startTimeWindowIndex === orderedTimeWindows.length - 1 || endTimeWindowIndex === 0) {
    return [messageGroup];
  }

  return [...orderedTimeWindows, null]
    .map<[Dayjs | null, Dayjs | null]>((d, idx, arr) => {
      if (idx === 0) {
        return [null, d];
      }
      return [arr[idx - 1], d];
    })
    .filter((value) => !!value)
    .map<ChatMessageGroup<T> | null>(([from, to]) => {
      let messages: TransformedMessage[];
      if (from === null) {
        messages = messageGroup.messages.filter((m) => dayjs(m.createdAt).isBefore(to));
      } else if (to === null) {
        messages = messageGroup.messages.filter((m) => dayjs(m.createdAt).isSameOrAfter(from));
      } else {
        messages = messageGroup.messages.filter(
          (m) => dayjs(m.createdAt).isSameOrAfter(from) && dayjs(m.createdAt).isBefore(to),
        );
      }
      if (messages.length === 0) {
        return null;
      }

      return {
        ...messageGroup,
        id: messages[0].id,
        createdAt: messages[0].createdAt,
        messages,
      };
    })
    .filter((messageGroup) => !!messageGroup)
    .map((messageGroup, idx) => ({
      ...messageGroup,
      label: idx === 0 ? messageGroup.label : undefined,
    }));
}
